import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Checkbox } from "@cappelendamm/design-system/react";
import { CheckoutForm } from "@/checkout/types";
import Link from "next/link";

type ConsentTextParts = {
  beforeText: string;
  clickableConsentText: string;
  afterText: string;
};

type NewsletterConsentFieldProps = {
  newsletterConsentText: string;
  newsletterTermsHref: string;
};

export const NewsletterConsentField = ({
  newsletterConsentText,
  newsletterTermsHref,
}: NewsletterConsentFieldProps) => {
  const { register } = useFormContext<CheckoutForm>();
  const getClickableConsentText = useMemo((): ConsentTextParts | null => {
    const firstUnderscore = newsletterConsentText.indexOf("_");
    const lastUnderscore = newsletterConsentText.lastIndexOf("_");
    if (firstUnderscore === -1 || firstUnderscore === lastUnderscore)
      return null;

    return {
      beforeText: newsletterConsentText.substring(0, firstUnderscore),
      clickableConsentText: newsletterConsentText.substring(
        firstUnderscore + 1,
        lastUnderscore,
      ),
      afterText: newsletterConsentText.substring(lastUnderscore + 1),
    };
  }, [newsletterConsentText]);

  return (
    <div className="flex items-center gap-3">
      <Checkbox
        id="newsletterConsent"
        className="hover:cursor-pointer"
        {...register("newsletterConsent", { required: false })}
      />
      <label htmlFor="newsletterConsent">
        {getClickableConsentText ? (
          <>
            {getClickableConsentText.beforeText}
            <Link
              href={newsletterTermsHref}
              scroll={false}
              className="underline focus:[box-shadow:var(--cvr-focus)]"
            >
              {getClickableConsentText.clickableConsentText}
            </Link>
            {getClickableConsentText.afterText}
          </>
        ) : (
          newsletterConsentText
        )}
      </label>
    </div>
  );
};
